const ACCOUNT = "41740027";
const PROPERTY = "74";
/**
 * Universal Analytics uses a tracking ID of the format UA-XXXXXX-xx. The first set of numbers
 * (i.e 41740027 in this case) refers to the account number, and the second set (74) the specific
 * property.
 * Google Analytics 4 measurement IDs start with "G-".
 */
export const LENS_DOT_SNAPCHAT_DOT_COM_GA = {
    UAId: `UA-${ACCOUNT}-${PROPERTY}`,
    measurementId: "G-613ZQZ10VJ",
};
/**
 * The cookie popup notice specifically uses the tracking ID without the first 'UA-' part
 */
export const COOKIE_NOTICE_GAID = `${ACCOUNT}-${PROPERTY}`;
